import React from "react";
import { spring, useCurrentFrame, useVideoConfig, interpolate } from "remotion";

interface OutroProps {
  keywords: string[];
  frame: number;
  fps: number;
}

export const RetroTerminalOutro: React.FC<OutroProps> = ({
  keywords,
  frame,
  fps,
}) => {
  const pulseScale = 1.0 + Math.sin((frame / fps) * Math.PI * 1.5) * 0.04;
  const buttonGlow = 15 + Math.sin((frame / fps) * Math.PI * 1.5) * 10;

  return (
          <div
            style={{
              width: "100%",
              background: "#080c08",
              border: "2px solid #224422",
              borderRadius: "16px",
              boxShadow:
                "0 20px 40px rgba(0,0,0,0.6), 0 0 15px rgba(57, 255, 20, 0.05)",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Terminal Window Header */}
            <div
              style={{
                height: "40px",
                background: "#121b12",
                borderBottom: "2px solid #224422",
                display: "flex",
                alignItems: "center",
                padding: "0 16px",
                gap: "8px",
              }}
            >
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#ff5f56",
                }}
              />
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#ffbd2e",
                }}
              />
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "#27c93f",
                }}
              />
              <div
                style={{
                  marginLeft: "12px",
                  fontFamily: "'JetBrains Mono', monospace",
                  color: "#39ff14",
                  fontSize: "12px",
                  fontWeight: 700,
                  opacity: 0.8,
                }}
              >
                bash --cta.sh
              </div>
            </div>

            <div
              style={{
                padding: "50px 40px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "35px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  color: "rgba(57, 255, 20, 0.4)",
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                guest@stdout:~$ cat cta.txt
              </div>

              <h2
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "44px",
                  fontWeight: 700,
                  lineHeight: 1.3,
                  color: "#39ff14",
                  margin: 0,
                  textShadow: "0 0 10px rgba(57, 255, 20, 0.3)",
                }}
              >
                &gt; Never Miss A Tech Shock
              </h2>

              {/* Monospace CTA Action Button */}
              <div
                style={{
                  transform: `scale(${pulseScale})`,
                  transition: "transform 0.1s ease",
                  cursor: "pointer",
                  width: "80%",
                  maxWidth: "350px",
                  background: "transparent",
                  border: "3px solid #39ff14",
                  padding: "16px 0",
                  boxShadow: `0 0 ${buttonGlow}px rgba(57, 255, 20, 0.3)`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontFamily: "'JetBrains Mono', monospace",
                    fontWeight: 700,
                    fontSize: "24px",
                    color: "#39ff14",
                    textTransform: "uppercase",
                  }}
                >
                  [ FOLLOW ]
                </span>
              </div>

              <div
                style={{
                  fontFamily: "'JetBrains Mono', monospace",
                  fontSize: "24px",
                  fontWeight: 700,
                  color: "#ffffff",
                }}
              >
                @TheDigitalBullet
              </div>
            </div>
          </div>
        )
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
